import { Container, Flex, Heading, Link, Text } from '@radix-ui/themes'
import { useNavigate } from 'react-router-dom'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <Container size="1">
      <Flex direction="column" gap="4">
        <Heading>Esto no estaba en el mapa...</Heading>
        <Text>La página que buscas no existe o se movió.</Text>
        <Flex gap="4">
          <Link onClick={() => navigate(-1)}>Volver atrás</Link>
          <Link href="/">Volver al inicio</Link>
        </Flex>
      </Flex>
    </Container>
  )
}

export default NotFoundPage
